import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  Box,
  Modal,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomTextField from "../components/TextField/CustomTextField";
import login from "../images/login.svg";
import { useUserLoginMutation } from "../../app/services/userCore";

const Login = () => {
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(["username", "o1HybridUser"]);
  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });

  const [
    loginApiCall,
    { data: responseData, isLoading, isError, isSuccess, error },
  ] = useUserLoginMutation();

  const handleInputs = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (userData.email.trim() === "") {
      toast.error("Please enter your email", {
        toastId: "loginEmailVal",
        autoClose: false,
      });
      return;
    }
    if (userData.password.trim() === "") {
      toast.error("Please enter your password", {
        toastId: "loginPassVal",
        autoClose: false,
      });
      return;
    }

    loginApiCall({
      email: userData.email,
      password: userData.password,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      localStorage.setItem("username", responseData.name);
      localStorage.setItem("o1HybridUser", responseData.token);
      setCookie("o1HybridUser", responseData.token, { maxAge: 21600 });
      setCookie("username", responseData.name, { maxAge: 21600 });
      navigate("/home");
    } else if (isError) {
      toast.error(error?.data?.message || "Invalid Credentials", {
        toastId: "invalidCred",
        autoClose: false,
      });
    }
  }, [isSuccess, isError]);

  return (
    <>
      {isLoading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1000,
          }}
          open={true}
        >
          <CircularProgress color="secondary" />
        </Backdrop>
      )}

      <Modal
        keepMounted
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <form>
            <Grid
              container
              maxWidth={"md"}
              spacing={4}
              justifyContent={"center"}
              alignItems={"center"}
              style={{
                backgroundColor: "rgba(40,44,75, 0.8)",
                padding: "3rem",
                boxShadow: 12,
              }}
            >
              <Grid item md={6} xs={12} display={{ md: "block", xs: "block" }}>
                <img
                  src={login}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
                style={{ textAlign: "center", color: "#fff" }}
              >
                <Typography
                  variant="h4"
                  style={{
                    textAlign: "center",
                    marginTop: "3%",
                    fontWeight: "bold",
                  }}
                >
                  SmartLearn
                </Typography>

                <CustomTextField
                  margin={"dense"}
                  fullWidth
                  name="email"
                  type="email"
                  label="Email"
                  onChange={handleInputs}
                  value={userData.email}
                  variant="filled"
                  color="secondary"
                  required
                />

                <CustomTextField
                  margin={"dense"}
                  fullWidth
                  name="password"
                  type="password"
                  label="Password"
                  onChange={handleInputs}
                  value={userData.password}
                  variant="filled"
                  color="secondary"
                  required
                />

                <button
                  className="btn-giveTest"
                  onClick={handleLogin}
                  style={{ marginTop: "1rem", position: "static" }}
                >
                  Login
                </button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        pauseOnHover
      />
    </>
  );
};

export default Login;
